"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _CTAButton = _interopRequireDefault(require("../CTAButton"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to display confirmation modal on calendly link click
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.show show or hide modal
 * @param {object} props.navigateLink link to open when click on continue
 * @param {object} props.onModelClose execute function on close of modal and link click
 *
 * @returns {React.ReactElement} calendly confirmation modal
 */
function CalendlyModal(props) {
  var handleCalendlyModalAction = calendlyLink => {
    if (!((0, _lodash.isEmpty)(calendlyLink) || (0, _lodash.isNil)(calendlyLink))) {
      if (typeof window !== 'undefined') window.open(calendlyLink, '_blank');
    }
    props.onModelClose();
  };
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal, {
    size: "md",
    show: props.show,
    onHide: props.onModelClose,
    centered: true,
    contentClassName: 'default',
    title: 'confirm calendly link navigation',
    id: 'modal-calendly'
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Header, {
    title: 'You are leaving MassMutual',
    onClose: () => props.onModelClose()
  }), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Body, null, /*#__PURE__*/_react.default.createElement("p", null, "You are now leaving the MassMutual website and will be directed to the Calendly website where you will be able to schedule an appointment.")), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: 'primary',
    label: 'Continue',
    dataId: 'calendly-continue',
    target: '_blank',
    linkAlt: 'Continue on calendly link',
    icon: 'icon-sm icon-external-link',
    iconDirection: 'left',
    onClick: () => handleCalendlyModalAction(props.navigateLink)
  })));
}
var _default = exports.default = CalendlyModal;